import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#F5F1EC] pt-20 pb-12">
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        {/* Nav columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-20 border-t border-[#D8D0C4] pt-16">
          <div>
            <h4 className="font-serif text-[#1A1A1A] text-base mb-4 tracking-wide">Experiences</h4>
            <div className="h-px w-full bg-[#C9A961]/40 mb-5" />
            <ul className="space-y-3">
              {["Private Dining", "Luxury Events", "Bespoke Hospitality", "Table Styling"].map((item) => (
                <li key={item}>
                  <Link to="/experiences" className="text-sm text-[#8A7F74] hover:text-[#1A1A1A] transition-colors font-light tracking-wide cursor-pointer">
                    {item}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/inquiry" className="text-sm text-[#C9A961] hover:text-[#1A1A1A] transition-colors font-light tracking-wide cursor-pointer">
                  Private Inquiry
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-[#1A1A1A] text-base mb-4 tracking-wide">About</h4>
            <div className="h-px w-full bg-[#C9A961]/40 mb-5" />
            <ul className="space-y-3">
              {["Our Story", "Philosophy", "Values", "The Team"].map((item) => (
                <li key={item}>
                  <Link to="/about" className="text-sm text-[#8A7F74] hover:text-[#1A1A1A] transition-colors font-light tracking-wide cursor-pointer">
                    {item}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/gallery" className="text-sm text-[#8A7F74] hover:text-[#1A1A1A] transition-colors font-light tracking-wide cursor-pointer">
                  Gallery
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-[#1A1A1A] text-base mb-4 tracking-wide">Discretion</h4>
            <div className="h-px w-full bg-[#C9A961]/40 mb-5" />
            <ul className="space-y-3">
              {["Privacy Policy", "Terms of Service", "Confidentiality"].map((item) => (
                <li key={item}>
                  <a href="#" rel="nofollow" className="text-sm text-[#8A7F74] hover:text-[#1A1A1A] transition-colors font-light tracking-wide cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-[#1A1A1A] text-base mb-4 tracking-wide">Connect</h4>
            <div className="h-px w-full bg-[#C9A961]/40 mb-5" />
            <ul className="space-y-3">
              <li>
                <a href="mailto:hello@tableprive.com" rel="nofollow" className="text-sm text-[#8A7F74] hover:text-[#1A1A1A] transition-colors font-light tracking-wide cursor-pointer">
                  hello@tableprive.com
                </a>
              </li>
              <li>
                <a href="tel:+442071234567" rel="nofollow" className="text-sm text-[#8A7F74] hover:text-[#1A1A1A] transition-colors font-light tracking-wide cursor-pointer">
                  +44 207 123 4567
                </a>
              </li>
              <li className="pt-2">
                <div className="flex items-center gap-4">
                  <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center text-[#8A7F74] hover:text-[#C9A961] transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-lg" />
                  </a>
                  <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center text-[#8A7F74] hover:text-[#C9A961] transition-colors cursor-pointer">
                    <i className="ri-pinterest-line text-lg" />
                  </a>
                  <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center text-[#8A7F74] hover:text-[#C9A961] transition-colors cursor-pointer">
                    <i className="ri-mail-line text-lg" />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Brand signature */}
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
          <div>
            <img
              src="https://static.readdy.ai/image/95b9eb99ec7b07a75e7e9971f3e8aa69/162509367b0586d9654593ed349a2eeb.png"
              alt="Table Privé"
              className="h-10 w-auto object-contain mb-4 opacity-70"
            />
            <div className="flex items-center gap-4">
              <div className="h-px w-16 bg-[#C9A961]/60" />
              <span className="text-xs text-[#B0A898] tracking-[0.2em] uppercase font-light">Est. 2019</span>
            </div>
          </div>
          <p className="text-xs text-[#B0A898] font-light tracking-wide">
            &copy; 2025 Table Privé. All rights reserved. Exclusive Dining &amp; Bespoke Hospitality.
          </p>
        </div>
      </div>
    </footer>
  );
}
